import initPromoCardCarousel from "../initPromoCardCarousel.js";

document.addEventListener("DOMContentLoaded", () => {
  initPromoCardCarousel();
});
